import lodash from "lodash";
import { createFieldTextArea } from "../../../../../components/input/template-builder/template-builder.logic";
import {
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callDepartment, callUserOperatorType, createFieldRegister } from "../../../../account/register/register.section";
import { callDocumentTypePerson, callUserRequestStatus, callUserRequestType } from "../tab-4/tab4.section";

export const createColumns = ({ personType }) => {
    return [
        createColumnTreeSelect({
            title: () => i18n.global.t("model.user.refDepartmentRegister"),
            dataIndex: "refUserTemp.refDepartmentRegister.nameTh",
            inputProp: () => ({
                list: callDepartment,
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refUserTemp.refDepartmentRegister.id" },
            width: 200
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userOperatorType.modelName"),
            dataIndex: "refUserTemp.userOperatorTypes.refOperatorType.value",
            dataIndexValue: ({ record }) => record.refUserTemp.userOperatorTypes.map(d => d.refOperatorType.value).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callUserOperatorType, optLabel: "value", mode: "multiple" }),
            search: { name: "refUserTemp.userOperatorTypes.refOperatorType.id", operator: "in", getValue: ({ value }) => value.map(d => d.id) }
        }),
        createColumnInputNumber({
            visible: () => personType === "1",
            title: () => i18n.global.t("views.register.idTax"),
            dataIndex: "refUserTemp.idCard",
            align: "center",
            comma: false,
            width: 170,
            search: { visible: () => personType === "1" }
        }),
        createColumnInput({
            visible: () => personType === "1",
            title: () => i18n.global.t("model.user.companyNameTh"),
            dataIndex: "refUserTemp.companyNameTh",
            search: { visible: () => personType === "1" }
        }),
        createColumnSelect({
            visible: () => personType === "2",
            title: () => i18n.global.t("model.user.refDocumentTypePerson"),
            dataIndex: "refUserTemp.refDocumentTypePerson.value",
            inputProp: () => ({ list: callDocumentTypePerson, optLabel: "value" }),
            search: { visible: () => personType === "2", name: "refUserTemp.refDocumentTypePerson.id" }
        }),
        createColumnInput({
            visible: () => personType === "2",
            title: () => i18n.global.t("model.user.idCard"),
            dataIndex: "refUserTemp.idCard",
            align: "center",
            comma: false,
            width: 170,
            search: { visible: () => personType === "2" }
        }),
        createColumnInput({
            visible: () => personType === "2",
            title: () => i18n.global.t("model.user.fullNameTh"),
            dataIndex: "refUserTemp.fullNameTh",
            search: { visible: () => personType === "2" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callUserRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userRequest.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callUserRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
};

export const createField = ({ props, data, key, isLoading }) => {
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldDesc({ props, data, key, isLoading }),
            ...createFieldRegister({
                props,
                data,
                key: `${prefix}refUserTemp`,
                isLoading,
                onLinkIdCard: onLinkIdCard({ props, data, key, isLoading })
            })
        ]
    });
};

export const createFieldDesc = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forOfficeRemark.0.remark`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forOfficeRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forOfficeRemark[0].remark = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const onLinkIdCard = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return d => {
        const result = [];
        if (model.refUserTemp.refPersonType?.key === "1") {
            if (!d?.companyType || d?.companyType?.indexOf(model.refUserTemp.refCompanyType.value) === -1)
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.refCompanyType")
                    })
                );
            if (!d?.companyNameTh || d?.companyNameTh?.indexOf(model.refUserTemp.companyNameTh) === -1)
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.companyNameTh")
                    })
                );
            if (!d?.companyNameEn || d?.companyNameEn?.indexOf(model.refUserTemp.companyNameEn) === -1)
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.companyNameEn")
                    })
                );
            if ((model.refUserTemp.idCard || "") !== (d?.idCard || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("views.register.idTax")
                    })
                );
        } else if (model.refUserTemp.refPersonType?.key === "2") {
            if ((model.refUserTemp.idCard || "") !== (d?.idCard || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("views.register.idCard")
                    })
                );
            if ((model.refUserTemp.birthDate || "") !== (d?.birthDate || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.birthDate")
                    })
                );
            if ((model.refUserTemp.refNationality?.value || "") !== (d?.nationalityDesc || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.refNationality")
                    })
                );
            if ((model.refUserTemp.refTitle?.value || "") !== (d?.titleName || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.refTitle")
                    })
                );
            if ((model.refUserTemp.firstNameTh || "") !== (d?.firstNameTh || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.firstNameTh")
                    })
                );
            if ((model.refUserTemp.middleNameTh || "") !== (d?.middleNameTh || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.middleNameTh")
                    })
                );
            if ((model.refUserTemp.lastNameTh || "") !== (d?.lastNameTh || ""))
                result.push(
                    i18n.global.t("views.register.linkWrong", {
                        text: i18n.global.t("model.user.lastNameTh")
                    })
                );
        }
        model.lastStatus.forOfficeRemark[0].remark = result.join("\r\n");
    };
};
